import React, { Component } from 'react'
import { connect } from 'react-redux'

import throttle from 'lodash/throttle'

import { addMessage } from '../actions/actions'

class EventListener extends Component {

    constructor(props) {
        super(props)
        this.props
    }

    componentWillReceiveProps(nextProps) {
    }

    componentDidMount() {
        let args = { 'dispatch': this.props.dispatch }
        let make_handler = function (args) {
            return function (e) {
                let user = JSON.parse(e.data).user
                args.dispatch( addMessage( user ))
            }
        }
        let source = new EventSource('https://stream.wikimedia.org/v2/stream/recentchange')
        source.addEventListener('message', throttle(make_handler(args), 200) )
    }

    render() {
        return ( 
            <div /> 
        )
    }
}

const mapStateToProps = state => {
    return {
        messages: state.messages
    }
}

export default connect(mapStateToProps)(EventListener)



// WEBPACK FOOTER //
// ./src/components/EventListener.js